"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _ExpansionPanel = _interopRequireDefault(require("@material-ui/core/ExpansionPanel"));
var _ExpansionPanelSummary = _interopRequireDefault(require("@material-ui/core/ExpansionPanelSummary"));
var _ExpansionPanelDetails = _interopRequireDefault(require("@material-ui/core/ExpansionPanelDetails"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));
var _styles = require("@material-ui/core/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ExpansionPanel = (0, _styles.withStyles)({
  root: {
    boxShadow: 'none',
    backgroundColor: 'transparent',
    '&:not(:last-child)': {},
    '&$expanded': {
      margin: 'auto'
    },
    '&:before': {
      display: 'none'
    }
  },
  expanded: {}
})(_ExpansionPanel["default"]);
var ExpansionPanelSummary = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      display: 'inline-flex',
      padding: theme.spacing(0, 3),
      textTransform: 'capitalize',
      borderBottom: 0,
      marginBottom: -1,
      color: theme.palette.darkGrey.main,
      fontWeight: 600,
      minHeight: theme.spacing(5),
      '&$expanded': {
        minHeight: theme.spacing(5)
      }
    },
    content: {
      margin: 0,
      '&$expanded': {
        margin: 0
      }
    },
    expanded: {},
    expandIcon: {
      padding: theme.spacing(0.5),
      color: theme.palette.primary.main
    }
  };
})(_ExpansionPanelSummary["default"]);
var ExpansionPanelDetails = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      padding: theme.spacing(1, 3),
      borderBottom: "1px solid ".concat(theme.palette.lightGrey.light),
      borderTop: "1px solid ".concat(theme.palette.lightGrey.light)
    }
  };
})(_ExpansionPanelDetails["default"]);
var useStyles = (0, _styles.makeStyles)({
  root: {
    borderRadius: 10,
    overflow: 'hidden'
  },
  title: {
    fontSize: 16,
    fontWeight: 'inherit'
  },
  icon: {
    fontSize: 18
  }
});
var Accordion = function Accordion(_ref) {
  var sections = _ref.sections,
    defaultExpandedPanel = _ref.defaultExpandedPanel;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root
  }, sections.map(function (_ref2, index) {
    var title = _ref2.title,
      content = _ref2.content;
    return /*#__PURE__*/_react["default"].createElement(ExpansionPanel, {
      key: title,
      square: true,
      defaultExpanded: defaultExpandedPanel === index
    }, /*#__PURE__*/_react["default"].createElement(ExpansionPanelSummary, {
      expandIcon: /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], {
        className: classes.icon
      })
    }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
      className: classes.title
    }, title)), /*#__PURE__*/_react["default"].createElement(ExpansionPanelDetails, null, content));
  }));
};
Accordion.propTypes = {
  sections: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    title: _propTypes["default"].string,
    content: _propTypes["default"].node
  })).isRequired,
  defaultExpandedPanel: _propTypes["default"].number
};
Accordion.defaultProps = {
  defaultExpandedPanel: undefined
};
var _default = exports["default"] = Accordion;